<div id="first-part">
  <div class="content wbce-container centered gap32" style="margin-top: 20px">
    <fieldset class="wbce">
      <legend>Project</legend>

      <mat-select
        (selectionChange)="onProjectServiceSelected()"
        [(value)]="projectName"
        >
        @for (project of projects; track project) {
          <mat-option
            [disabled]="project.isDisabled()"
            [value]="project.projectName"
            >
            {{ project?.projectName }}
          </mat-option>
        }
      </mat-select>
    </fieldset>

    <fieldset class="wbce">
      <legend>Service</legend>
      <mat-select
        (selectionChange)="onProjectServiceSelected()"
        [(value)]="serviceName"
        >
        @for (serviceItemMenu of servicesMenu; track serviceItemMenu) {
          <mat-option
            [disabled]="serviceItemMenu.isDisabled"
            [value]="serviceItemMenu.name"
            >
            {{ serviceItemMenu?.name }}
          </mat-option>
        }
      </mat-select>
    </fieldset>
  </div>

  <div id="line"></div>

  <div class="content wbce-container centered">
    @for (item of menu; track item) {
      <app-wbce-button
        class="menu-list"
        [selected]="item.route === currentActiveRoute"
        [isDisabled]="item.workInProgress"
        [role]="item.readRole ? readRole : undefinedRole"
        [type]="'menu-list'"
        routerLink="{{ item.route }}"
        >
        <div class="borderd-color">
          <mat-icon
            mat-list-icon
            class="shape"
            [svgIcon]="item.shape"
            >
          </mat-icon>
          <span style="text-wrap: nowrap">{{ item.name }}</span>
          @if (item.workInProgress) {
            <mat-icon
              mat-list-icon
              class="shape"
              fontSet="fa"
              fontIcon="fa-person-digging"
            ></mat-icon>
          }
        </div>
      </app-wbce-button>
    }
  </div>

  <div id="line"></div>

  <div class="content wbce-container centered">
    @for (service of servicesToDisplay; track service; let index = $index) {
      <app-wbce-button
        class="menu-list"
        [type]="'menu-list'"
        [matMenuTriggerFor]="menuService"
        >
        <div>
          <mat-icon
            mat-list-icon
            class="shape"
            [svgIcon]="technosName[service.techno.id]"
            >
          </mat-icon>
          <span>{{ service?.calculatedDisplayName }}</span>
        </div>
      </app-wbce-button>
      <mat-menu #menuService="matMenu">
        @for (ctxt of contexts; track ctxt) {
          <button
            mat-menu-item
                        [matTooltip]="
                            service.isDisabled(ctxt)
                                ? 'No versions have been deployed. Go to the version tab and deploy a version.'
                                : ''
                        "
            (click)="openContentInNewTab(service, ctxt)"
            [matTooltipPosition]="'after'"
            [disabled]="service?.isDisabled(ctxt)"
            >
            <span>Access to {{ ctxt.toLowerCase() }}</span>
          </button>
        }
      </mat-menu>
    }
  </div>

  @if (serviceName === ALL_SERVICES) {
    <div id="line"></div>
    <div class="content wbce-container centered">
      @for (tool of tools; track tool; let index = $index) {
        <app-wbce-button
          class="menu-list"
          [type]="'menu-list'"
          [matMenuTriggerFor]="menuTools"
          >
          <div>
            <mat-icon
              mat-list-icon
              class="shape"
              [svgIcon]="tool.logo"
              >
            </mat-icon>
            <span style="text-wrap: nowrap">{{ tool.name }}</span>
          </div>
        </app-wbce-button>
        <mat-menu #menuTools="matMenu">
          <button mat-menu-item (click)="openToolInNewTab(tool)">
            <span>Access to website</span>
          </button>
        </mat-menu>
      }
    </div>
  }
</div>
